import { Box, CustomContainer, DesktopItem } from 'components';
import React, { ReactElement, useEffect } from 'react';
import { useUser } from 'store/userContext';
import { useTranslation } from 'react-i18next';
import './panel.scss';
import {
  MedicalExaminationRepository,
  TrainingsRepository,
} from 'api/repository';
import QualificationsRepository from 'api/repository/QualificationsRepository';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { appRoutersUser } from 'routes';
import Tooltip from 'rc-tooltip';

const Panel = (): ReactElement => {
  const { userId, hydrated } = useUser();
  const { t } = useTranslation('employee');

  const history = useHistory();

  const [getMedicalUpcoming, dataMedicalUpcoming] =
    MedicalExaminationRepository.useGetMedicalExaminationUpcoming();
  const [getTrainingsUpcoming, dataTrainingsUpcoming] =
    TrainingsRepository.useGetTrainingsUpcoming();
  const [getQualificationsUpcoming, dataQualificationsUpcoming] =
    QualificationsRepository.useGetQualificationsUpcoming();

  useEffect(() => {
    if (userId && userId !== null) {
      getMedicalUpcoming({ userId });
      getTrainingsUpcoming({ userId });
      getQualificationsUpcoming({ userId });
    }
  }, [userId]);

  //   START Text

  const checkText = (
    date: string | undefined,
    labels: {
      upcoming: string;
      expired: string;
    }
  ) => {
    if (date && date !== null) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const targetDate = new Date(date);
      targetDate.setHours(0, 0, 0, 0);

      if (targetDate.getTime() >= today.getTime()) {
        return labels.upcoming;
      }

      if (targetDate.getTime() < today.getTime()) {
        return labels.expired;
      }
    }
    return null;
  };

  // END Text

  return (
    <CustomContainer allowGrow>
      <>
        <Box
          id="userDesktop"
          name={t('panel.userDesktop')}
          svgIcon="desktop"
          noContentStyle
        >
          <div id="userDesktopBox">
            {dataMedicalUpcoming && dataMedicalUpcoming !== null ? (
              <DesktopItem id="medical" name={t('panel.userMedicalDesktop')}>
                <div className="upcomingBox">
                  {dataMedicalUpcoming?.firstDate &&
                  dataMedicalUpcoming?.firstDate !== null ? (
                    <div className="upcomingTextBox">
                      <div className="textUpcoming">
                        {checkText(dataMedicalUpcoming?.firstDate, {
                          upcoming: t('panel.upcomingMedicalExamination'),
                          expired: t('panel.expiredMedicalExamination'),
                        })}
                      </div>
                      <div className="dateUpcoming">
                        {dataMedicalUpcoming?.firstDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="upcomingDetail">
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.currentDates')}
                    >
                      <div className="dataNumbers greenNumbers">
                        {dataMedicalUpcoming?.warnGreen}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.upcomingDeadlines')}
                    >
                      <div className="dataNumbers yellowNumbers">
                        {dataMedicalUpcoming?.warnYellow}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.deadlinesEnding')}
                    >
                      <div className="dataNumbers redNumbers">
                        {dataMedicalUpcoming?.warnRed}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.expired')}
                    >
                      <div className="dataNumbers blackNumbers">
                        {dataMedicalUpcoming?.warnBlack}
                      </div>
                    </Tooltip>
                  </div>
                  <Button
                    className="green"
                    // onClick={() => history.push('/panel/teczka-pracownika/badania')}
                    onClick={() =>
                      history.push(appRoutersUser.userEmployeeMedical)
                    }
                  >
                    {t('panel.goToDetails')}
                  </Button>
                </div>
              </DesktopItem>
            ) : (
              ''
            )}
            {dataTrainingsUpcoming?.firstDate &&
            dataTrainingsUpcoming?.firstDate !== null ? (
              <DesktopItem
                id="trainings"
                name={t('panel.userTrainingsDesktop')}
              >
                <div className="upcomingBox">
                  {dataTrainingsUpcoming && dataTrainingsUpcoming !== null ? (
                    <div className="upcomingTextBox">
                      <div className="textUpcoming">
                        {checkText(dataTrainingsUpcoming?.firstDate, {
                          upcoming: t('panel.upcomingTrainings'),
                          expired: t('panel.expiredTrainings'),
                        })}
                      </div>
                      <div className="dateUpcoming">
                        {dataTrainingsUpcoming?.firstDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="upcomingDetail">
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.currentDates')}
                    >
                      <div className="dataNumbers greenNumbers">
                        {dataTrainingsUpcoming?.warnGreen}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.upcomingDeadlines')}
                    >
                      <div className="dataNumbers yellowNumbers">
                        {dataTrainingsUpcoming?.warnYellow}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.deadlinesEnding')}
                    >
                      <div className="dataNumbers redNumbers">
                        {dataTrainingsUpcoming?.warnRed}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.expired')}
                    >
                      <div className="dataNumbers blackNumbers">
                        {dataTrainingsUpcoming?.warnBlack}
                      </div>
                    </Tooltip>
                  </div>
                  <Button
                    className="green"
                    // onClick={() => history.push('/panel/teczka-pracownika/szkolenia')}
                    onClick={() =>
                      history.push(appRoutersUser.userEmployeeTrainings)
                    }
                  >
                    {t('panel.goToDetails')}
                  </Button>
                </div>
              </DesktopItem>
            ) : (
              ''
            )}
            {dataQualificationsUpcoming &&
            dataQualificationsUpcoming !== null ? (
              <DesktopItem
                id="qualifications"
                name={t('panel.userQualificationsDesktop')}
              >
                <div className="upcomingBox">
                  {dataQualificationsUpcoming?.firstDate &&
                  dataQualificationsUpcoming?.firstDate !== null ? (
                    <div className="upcomingTextBox">
                      <div className="textUpcoming">
                        {checkText(dataQualificationsUpcoming?.firstDate, {
                          upcoming: t('panel.upcomingQualifications'),
                          expired: t('panel.expiredQualifications'),
                        })}
                      </div>
                      <div className="dateUpcoming">
                        {dataQualificationsUpcoming?.firstDate}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="upcomingDetail">
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.currentDates')}
                    >
                      <div className="dataNumbers greenNumbers">
                        {dataQualificationsUpcoming?.warnGreen}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.upcomingDeadlines')}
                    >
                      <div className="dataNumbers yellowNumbers">
                        {dataQualificationsUpcoming?.warnYellow}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.deadlinesEnding')}
                    >
                      <div className="dataNumbers redNumbers">
                        {dataQualificationsUpcoming?.warnRed}
                      </div>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="customTooltip"
                      placement="top"
                      overlay={t('panel.expired')}
                    >
                      <div className="dataNumbers blackNumbers">
                        {dataQualificationsUpcoming?.warnBlack}
                      </div>
                    </Tooltip>
                  </div>
                  <Button
                    className="green"
                    // onClick={() =>
                    // history.push('/panel/teczka-pracownika/uprawnienia')
                    // }
                    onClick={() =>
                      history.push(appRoutersUser.userEmployeeQualifications)
                    }
                  >
                    {t('panel.goToDetails')}
                  </Button>
                </div>
              </DesktopItem>
            ) : (
              ''
            )}
          </div>
        </Box>
      </>
    </CustomContainer>
  );
};

export default Panel;
